import { render, staticRenderFns } from "./MyProfiles.vue?vue&type=template&id=69739d45"
import script from "./MyProfiles.vue?vue&type=script&lang=js"
export * from "./MyProfiles.vue?vue&type=script&lang=js"
import style0 from "./MyProfiles.vue?vue&type=style&index=0&id=69739d45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports